// packages/shared-hooks/src/lead-tasks/useRescheduleLeadTask.ts
//
// `PATCH /lead-tasks/:id` — rescheduling or renaming a MANUAL self-task
// (#1803/#1804). The backend refuses non-MANUAL or completed rows. Success
// invalidates the whole `lead-tasks` prefix so the per-lead list and My Day
// re-bucket the row (clearing `dueAt` removes it from My Day).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LeadTaskSchema, type RescheduleLeadTaskInput, type LeadTask } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadTasksKeys } from './keys.js';

export function useRescheduleLeadTask(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LeadTask, unknown, RescheduleLeadTaskInput>({
    mutationFn: (input) => client.patch<LeadTask>(`/lead-tasks/${id}`, input, {}, LeadTaskSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadTasksKeys.all });
    },
  });
}
